import { reactive } from 'vue'

import { User } from '@/shared/interfaces/User'

/** Всплывашка о новом сообщении, показывается поверх экрана звонка. */
export interface CallNotification {
  id: number
  title: string
  text: string
  user: User | null
}

const state = reactive<{ items: CallNotification[] }>({ items: [] })
let seq = 0

export function useCallNotifications(): { items: CallNotification[] } {
  return state
}

/** Добавить уведомление (авто-скрытие через 5 секунд, не больше 3 на экране). */
export function pushCallNotification(n: Omit<CallNotification, 'id'>): void {
  const id = ++seq
  state.items.push({ ...n, id })
  if (state.items.length > 3) {
    state.items.splice(0, state.items.length - 3)
  }
  setTimeout(() => removeCallNotification(id), 5000)
}

export function removeCallNotification(id: number): void {
  const i = state.items.findIndex((x) => x.id === id)
  if (i !== -1) state.items.splice(i, 1)
}
